export default "__VITE_ASSET__CEQUkYw1__"